import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type {
  WarehouseBase,
  WarehouseById,
  WarehouseCreatePayload,
  WarehouseUpdatePayload,
  WarehouseItem,
  WarehouseItemListParams,
} from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/warehouse`;

export const getItemList = async (params?: WarehouseItemListParams): Promise<ApiResponse<WarehouseItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<WarehouseItem[]>>(`${BASE}/item-list`, { params });
  return data;
};

export const getList = async (params?: RequestParams): Promise<ApiResponseList<WarehouseBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<WarehouseBase>>(`${BASE}/index`, { params });
  return data;
};

export const getById = async (id: number): Promise<ApiResponse<WarehouseById>> => {
  const { data } = await axiosInstance.get<ApiResponse<WarehouseById>>(`${BASE}/show`, { params: { id } });
  return data;
};

export const create = async (payload: WarehouseCreatePayload): Promise<ApiResponse<WarehouseById>> => {
  const { data } = await axiosInstance.post<ApiResponse<WarehouseById>>(`${BASE}/create`, payload);
  return data;
};

export const update = async (payload: WarehouseUpdatePayload): Promise<ApiResponse<WarehouseById>> => {
  const { data } = await axiosInstance.post<ApiResponse<WarehouseById>>(`${BASE}/update`, payload);
  return data;
};

export const remove = async (id: number): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/delete`, { id });
  return data;
};
